export const observeElementOnScreen = (target, offset = 0) => {
    if (!target) return;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("show");
                }
            });
        },
        {
            root: null,
            rootMargin: `${offset}px`,
            threshold: 0,
        },
    );

    observer.observe(target);
    return observer;
};

export const createLinkClick = url => {
    const a = document.createElement('a');
    a.href = url;
    a.click();
    a.remove()
}
